import React, { useState } from 'react';
import axios from 'axios';

function LandingPage() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    companyName: '',
    phone: '',
    siaIdent: '',
    gdprConsent: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!formData.gdprConsent) {
      setError('Bitte akzeptieren Sie die Datenschutzerklärung');
      setLoading(false);
      return;
    }

    try {
      await axios.post('/api/auth/register', {
        email: formData.email,
        password: formData.password,
        companyName: formData.companyName,
        phone: formData.phone,
        siaIdent: formData.siaIdent,
        gdprConsent: formData.gdprConsent
      });
      setSuccess(true);
      setFormData({
        email: '',
        password: '',
        companyName: '',
        phone: '',
        siaIdent: '',
        gdprConsent: false
      });
    } catch (err) {
      setError(err.response?.data?.error || 'Registrierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-gray-800 rounded-lg shadow-xl p-8 text-center">
          <div className="text-green-500 text-6xl mb-4">✓</div>
          <h2 className="text-2xl font-bold text-white mb-4">Registrierung erfolgreich!</h2>
          <p className="text-gray-300 mb-4">
            Wir haben Ihnen eine Bestätigungsmail an <strong>{formData.email}</strong> gesendet.
          </p>
          <p className="text-gray-400 text-sm">
            Bitte klicken Sie auf den Link in der E-Mail, um Ihr Konto zu aktivieren.
          </p>
          <button
            onClick={() => setSuccess(false)}
            className="mt-6 text-blue-400 hover:text-blue-300"
          >
            Zurück zur Startseite
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Alarm Dashboard
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-4">
            Die professionelle Alarmzentralen-Verwaltung für Errichter
          </p>
          <p className="text-lg text-gray-400">
            Testen Sie jetzt 14 Tage kostenlos - keine Kreditkarte erforderlich
          </p>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition">
            <div className="text-4xl mb-4">🏢</div>
            <h3 className="text-xl font-bold mb-3">Multi-Zentralen Support</h3>
            <p className="text-gray-400">
              Verwalten Sie beliebig viele Jablotron und Ajax Alarmzentralen in einem Dashboard
            </p>
          </div>

          <div className="bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition">
            <div className="text-4xl mb-4">🗺️</div>
            <h3 className="text-xl font-bold mb-3">Interaktive Lagepläne</h3>
            <p className="text-gray-400">
              Platzieren Sie Melder auf Lageplänen und sehen Sie Alarme in Echtzeit
            </p>
          </div>

          <div className="bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition">
            <div className="text-4xl mb-4">⚡</div>
            <h3 className="text-xl font-bold mb-3">Echtzeit-Monitoring</h3>
            <p className="text-gray-400">
              Empfangen Sie Alarme per SIA-DC Protokoll in Echtzeit via UDP/TCP
            </p>
          </div>
        </div>

        {/* Registration Form */}
        <div className="max-w-md mx-auto bg-gray-800 rounded-lg shadow-xl p-8">
          <h2 className="text-2xl font-bold mb-6 text-center">Jetzt kostenlos testen</h2>
          
          {error && (
            <div className="bg-red-900/50 border border-red-500 text-red-200 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2" htmlFor="email">
                E-Mail
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:border-blue-500"
                placeholder="ihre@email.de"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2" htmlFor="password">
                Passwort
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength="8"
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:border-blue-500"
                placeholder="Mindestens 8 Zeichen"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2" htmlFor="companyName">
                Firma
              </label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:border-blue-500"
                placeholder="Ihre Firma"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2" htmlFor="phone">
                Telefon
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:border-blue-500"
                placeholder="+49 123 456789"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2" htmlFor="siaIdent">
                SIA Ident-Nummer
              </label>
              <input
                type="number"
                id="siaIdent"
                name="siaIdent"
                value={formData.siaIdent}
                onChange={handleChange}
                required
                min="1"
                max="9999"
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:border-blue-500"
                placeholder="z.B. 1004"
              />
              <p className="text-xs text-gray-500 mt-1">
                Die Ident-Nummer Ihrer Alarmzentrale (1-9999)
              </p>
            </div>

            <div className="mb-6">
              <label className="flex items-start">
                <input
                  type="checkbox"
                  name="gdprConsent"
                  checked={formData.gdprConsent}
                  onChange={handleChange}
                  required
                  className="mt-1 mr-2"
                />
                <span className="text-sm text-gray-400">
                  Ich akzeptiere die{' '}
                  <a href="#datenschutz" className="text-blue-400 hover:underline">
                    Datenschutzerklärung
                  </a>{' '}
                  und{' '}
                  <a href="#agb" className="text-blue-400 hover:underline">
                    AGB
                  </a>
                </span>
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Wird gesendet...' : '14 Tage kostenlos testen'}
            </button>
          </form>

          <p className="text-center text-sm text-gray-500 mt-4">
            Bereits registriert?{' '}
            <a href="/login" className="text-blue-400 hover:underline">
              Hier anmelden
            </a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-800 mt-16 py-8">
        <div className="container mx-auto px-4 text-center">
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <a href="#impressum" className="text-gray-400 hover:text-white transition">
              Impressum
            </a>
            <a href="#datenschutz" className="text-gray-400 hover:text-white transition">
              Datenschutz
            </a>
            <a href="#agb" className="text-gray-400 hover:text-white transition">
              AGB
            </a>
          </div>
          <p className="text-gray-500 text-sm">
            © 2025 Alarm Dashboard. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
